import { Textual }			from "@v3/data/textual";
import { Fqdn, IpV4, IpV6 }	from "@v3/data/primitive";

// ATTENTION this is always lowercase
export type HostIdentifier	= Textual.Value<typeof Base>;

const Base	=
	Textual.predicate(
		"HostIdentifier",
		it => Fqdn.is(it) || IpV4.is(it) || IpV6.is(it),
		"must be an fqdn, an ipv4 or an ipv6"
	);

namespace Extension {
	// external data may be uppercase
	export const reallyParse	= (it:string):HostIdentifier|null => Base.fromString(it.toLowerCase());
}

export const HostIdentifier	= { ...Extension, ...Base };
